<template>
  <div class="event-form event-form--deployments" v-if="newEvent">
    <Tabs v-model:value="value">
      <TabList>
        <Tab value="0">Zones ({{ newEvent.zones.length }})</Tab>
        <Tab value="1">Clusters ({{ newEvent.clusters.length }})</Tab>
        <Tab value="2">Sensors ({{ newEvent.zones.length }})</Tab>
      </TabList>
      <TabPanels>
        <TabPanel value="0">
          <DeploymentZones v-model:newEvent="newEvent" @onClusterAdded="onClusterAdded" />
        </TabPanel>
        <TabPanel value="1">
          <DeploymentClusters v-model:newEvent="newEvent" />
        </TabPanel>
        <TabPanel value="2">
          <DeploymentSensors
            v-model:newEvent="newEvent"
            :sensorDistanceOptions="sensorDistanceOptions"
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  </div>
</template>

<script setup lang="ts">
import { ref, type Ref } from 'vue';

import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primevue';

import type { EventTypeNew } from '@/types/Event';

import DeploymentClusters from '@/components/events/DeploymentClusters.vue';
import DeploymentSensors from '@/components/events/DeploymentSensors.vue';
import DeploymentZones from '@/components/events/DeploymentZones.vue';
import type { SensorDistanceSettingType, SensorIndexQuery } from '@/types/Sensor';
import { getSensorRangeOptions, getSensors } from '@/utils/api';
import { useUserStore } from '@/stores/user';

const newEvent = defineModel<EventTypeNew>('newEvent');
const value = ref('0');
const loading = ref(true);

const onClusterAdded = () => {
  value.value = '1';
};

const userStore = useUserStore();
const sensorDistanceOptions = ref<SensorDistanceSettingType[]>([]);

const sensorParams: Ref<SensorIndexQuery> = ref({
  page: 1,
  results_per_page: 5,
  search: '',
  sortDesc: false,
  sort: 'name',
});

const getSensorData = async () => {
  loading.value = true;

  const newParams = { ...sensorParams.value };
  getSensors(userStore.accessToken, newParams).then((response) => {
    const { data } = response;

    if (data.length) {
      getSensorRangeOptions(userStore.accessToken, userStore.isStaff, data[0].id).then((resp) => {
        sensorDistanceOptions.value = resp;
      });
    }

    loading.value = false;
  });
};

getSensorData();
</script>
